import "./EquityOrderSummaryComponent.scss";
import template from "./EquityOrderSummaryComponent.html";
import {IComponentOptions} from "angular";
import {OrderVettingResponse} from "../../../types/OrderVettingResponse";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";

export const EquityOrderSummary = "tfEquityOrderSummary";

export function equityOrderSummary(): IComponentOptions {
    return {
        template,
        bindings: {
            order: "<",
            response: "<"
        },
        controllerAs: "ctrl",
        controller: EquityOrderSummaryComponentController
    };
}

export class EquityOrderSummaryComponentController {
    /** @input */
    public readonly response: OrderVettingResponse | null;
    public readonly order: EquityWizardData;

    public get currentBalance(): number | null {
        if (this.response == null) {
            return null;
        } else {
            return this.response.scenarioSummary.currentBalance;
        }
    }

    public get costOfTrade(): number | null {
        if (this.response == null) {
            return null;
        } else {
            return this.response.scenarioSummary.totalCost;
        }
    }

    public get totalFees(): number | null {
        if (this.response == null) {
            return null;
        } else {
            return Object.values(this.response.scenarioSummary.fees)
                         .reduce((acc, next) => acc + next, 0);
        }
    }

    public get totalCost(): number | null {
        const tradeCost = this.costOfTrade;
        const fees = this.totalFees;
        if ((tradeCost == null) || (fees == null)) {
            return null;
        } else {
            return tradeCost - fees;
        }
    }

    public get cashAfterTrade(): number | null {
        const before = this.currentBalance;
        const cost = this.totalCost;
        if ((before == null) || (cost == null)) {
            return null;
        } else {
            return before + cost;
        }
    }
}
